<template>
  <div
    class="h-header fixed top-0 right-0 z-50 w-full bg-header shadow-header dark:bg-black dark:shadow-[0px_0px_12px_rgba(255,255,255,0.4)]"
  >
    <div class="f-c h-full">
      <Logo />
      <div class="ml-auto f-c mr-5 gap-5">
        <ThemeToggle />
        <PhoneMenu />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// vue
import Logo from './components/Logo.vue';
import PhoneMenu from './components/PhoneMenu.vue';
</script>
